module.exports = __webpack_public_path__ + "img/3-2.c7a5786e.svg";